// extracted by mini-css-extract-plugin
export default {"ul":"text-list_ul__Qjtp5"};